/**
 * Checkout age confirmation — product.verifyAge === true means 18+ required.
 */

export const isAgeRestrictedProduct = (productOrItem) => {
  if (!productOrItem || typeof productOrItem !== "object") return false;
  // Cart line may carry the flag on the line or on nested product.
  if (productOrItem.verifyAge === true || productOrItem.verify_age === true)
    return true;
  if (
    productOrItem.product?.verifyAge === true ||
    productOrItem.product?.verify_age === true
  )
    return true;
  return false;
};

/** True when any active cart line needs the over-18 checkbox. */
export const cartRequiresAgeConfirmation = (cartItems) =>
  Array.isArray(cartItems) &&
  cartItems.some(
    (item) =>
      (item?.quantity == null || Number(item.quantity) > 0) &&
      isAgeRestrictedProduct(item),
  );
